import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { baseColors, colors } from '../../Themes/colors';
import { WIZARD_COLORS } from '../../components/FormComponents/dynamicForm';
var CreateApplicationWrapper = styled(Box)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'column',
        padding: '12px 16px 0',
        height: 'calc(100vh - 45px)',
        overflow: 'hidden',
        backgroundColor: baseColors.successPreset[20],
        '& .context-bar': {
            flexShrink: 0,
            backgroundColor: baseColors.fullWhite,
            borderRadius: 8,
            padding: '12px 16px',
            marginBottom: 12,
        },
        '& .context-bar-title': {
            fontSize: 16,
            fontWeight: 700,
            color: WIZARD_COLORS.ink,
            marginBottom: 10,
        },
        '& .context-chips': {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 12,
        },
        '& .context-chip': {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            minHeight: 30,
            padding: '4px 10px',
            borderRadius: 6,
            border: "1px solid ".concat(colors.greyShades[20]),
            backgroundColor: baseColors.fullWhite,
            color: WIZARD_COLORS.ink,
            '& .context-chip-label': { fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap' },
            '& .context-chip-value': { fontSize: 11, fontWeight: 400, whiteSpace: 'nowrap' },
        },
        '& .wizard-body': (_b = {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                alignItems: 'stretch',
                gap: 12,
                overflow: 'hidden'
            },
            _b[theme.breakpoints.down('md')] = {
                flexDirection: 'column',
                overflowY: 'auto',
                paddingBottom: 16,
            },
            _b),
        '& .step-rail': (_c = {
                flexShrink: 0,
                width: 136,
                alignSelf: 'stretch',
                overflowY: 'auto',
                backgroundColor: baseColors.fullWhite,
                borderRadius: 8,
                padding: '16px 8px'
            },
            _c[theme.breakpoints.down('md')] = {
                width: '100%',
                alignSelf: 'auto',
                overflowY: 'visible',
            },
            _c),
        '& .form-panel': (_d = {
                flex: 1,
                minWidth: 0,
                minHeight: 0,
                overflowY: 'auto',
                overscrollBehavior: 'contain',
                backgroundColor: baseColors.fullWhite,
                borderRadius: 8,
                padding: '14px 16px 20px'
            },
            _d[theme.breakpoints.down('md')] = {
                overflowY: 'visible',
            },
            _d),
        '& .autofill-banner': {
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            flexWrap: 'wrap',
            borderRadius: 8,
            padding: '10px 14px',
            marginBottom: 16,
            background: 'linear-gradient(90deg, #EAF3FF 0%, #F1F7FF 60%, #F7FAFF 100%)',
        },
        '& .autofill-copy': {
            flex: 1,
            minWidth: 220,
        },
        '& .autofill-drop': {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            minWidth: 240,
            padding: '8px 12px',
            borderRadius: 6,
            border: "1px dashed ".concat(baseColors.successPreset[30]),
            backgroundColor: baseColors.fullWhite,
            cursor: 'pointer',
            '&:hover': { backgroundColor: '#F5FBFA' },
            '&:disabled': { cursor: 'not-allowed', opacity: 0.6 },
        },
        '& .wizard-footer': {
            flexShrink: 0,
            zIndex: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            flexWrap: 'wrap',
            margin: '0 -16px',
            padding: '12px 20px',
            backgroundColor: baseColors.fullWhite,
            borderTop: "1px solid ".concat(colors.greyShades[20]),
        },
    });
});
export var SUBMIT_ERROR_SX = { mb: 2, fontSize: 13 };
export var FOOTER_ICON_SX = { fontSize: 16 };
export var FOOTER_PRIMARY_COLOR = baseColors.bluePreset[10];
export var INERT_WHEN_DISABLED_SX = {
    '&.MuiButton-root.Mui-disabled': { pointerEvents: 'none' },
};
export var stepPanelSx = function (isActive) { return ({
    display: isActive ? 'block' : 'none',
}); };
export default CreateApplicationWrapper;
export var PREVIEW_DIALOG_PAPER_SX = {
    borderRadius: '12px',
};
export var PREVIEW_STEP_TITLE_SX = {
    fontSize: 15,
    fontWeight: 700,
    color: WIZARD_COLORS.ink,
    mb: 1,
};
export var PREVIEW_SECTION_TITLE_SX = {
    fontSize: 13,
    fontWeight: 600,
    color: WIZARD_COLORS.ink,
    mb: 1,
};
export var PREVIEW_RECORD_SX = {
    backgroundColor: WIZARD_COLORS.page,
    borderRadius: '8px',
    padding: '12px 14px',
    mb: 1.5,
};
export var PREVIEW_LABEL_SX = {
    fontSize: 11,
    color: WIZARD_COLORS.muted,
    mb: 0.25,
};
export var PREVIEW_VALUE_SX = {
    fontSize: 13,
    fontWeight: 500,
    color: WIZARD_COLORS.ink,
    wordBreak: 'break-word',
};
